import { FormInstance } from 'antd';
import { Rule } from 'antd/lib/form';

import { ForgotFormForm } from '@customTypes/users/authForm.types';
import { authEmailRule } from '@helpers/validationHelpers';
import { useDebouncedValidation } from '@hooks/useDebouncedValidation';

interface UseValidationReturn {
    codeRules: Rule[];
    emailRules: Rule[];
}

export const useValidation = (
    form: FormInstance<ForgotFormForm>,
    isLoading: boolean
): UseValidationReturn => {
    useDebouncedValidation({
        formInstance: form,
        fieldName: 'recoveryEmail',
        skipValidation: isLoading
    });

    useDebouncedValidation({
        formInstance: form,
        fieldName: 'code',
        skipValidation: isLoading
    });

    const codeRules: Rule[] = [
        {
            required: true,
            message: 'Enter Code'
        },
        {
            max: 100,
            message: 'Max 100 symbols'
        }
    ];

    const emailRules: Rule[] = [{ ...authEmailRule, required: true }];

    return {
        codeRules,
        emailRules
    };
};
